<template>
  <div class="header-container">
    <div>
      <router-link to="/">
        <img loading="prelaod" decoding="async" class="img-fluid" width="160" src="@/assets/logo.png" alt="surveasy">
      </router-link>
    </div>

    <div class="header-right">
      <a id="header-text" v-if="this.$store.state.userName == null" @click="requireLogin()">로그인 / 회원가입</a>
      <div class="header-user" v-else>
        <span class="header-username">{{this.$store.state.userName}}님</span>
        <router-link to="/mypage" class="header-mypage-btn">마이페이지</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { instanceWithAuth } from '../api/index'
import { requireLogin } from '../plugins/auth-modal'
export default {
  name: 'HeaderContainer',
  computed: {
    user() {
      return this.$store.state.userName;
    },
  },

  mounted(){
    this.checkLoginState()
  },

  methods: {
    requireLogin,
    async checkLoginState(){
      try {
        const response = await instanceWithAuth.get("/user")
        if(response.status == 200){
          this.$store.dispatch('setCurrentUserAdmin')
        }
      }catch(error){

        if(this.$store.state.currentUser != null){
          this.$store.dispatch('setCurrentUser', {payload: this.$store.state.currentUser.email})

        }
      }
    }
  }

}
</script>

<style>
.header-container {
  display: flex;
  justify-content: space-between; /* 수평 가운데 정렬 */
  align-items: center; /* 수직 가운데 정렬 */
  flex-direction: row;
  gap: 12px;
  padding: 0 30px;
}

.header-container .img-fluid {
  padding-top: 10px;
}

.header-container
.header-container a {
  color: #000000;
  text-decoration: none;
}
#header-text {
  color: #0AAC00;
  text-decoration: none;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 1.1rem;
  cursor: pointer;
}

.header-right {
  display: flex;
  align-items: center;
  min-width: 0;
}

.header-user {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  min-width: 0;
  font-family: var(--font-sans);
}

.header-username {
  overflow: hidden;
  max-width: 160px;
  font-size: 14px;
  font-weight: var(--font-weight-medium);
  color: var(--ink-700);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.header-mypage-btn {
  flex-shrink: 0;
  border: 1px solid var(--green-500);
  border-radius: var(--radius-md);
  padding: 7px 14px;
  font-size: 13px;
  font-weight: var(--font-weight-semibold);
  color: var(--green-600);
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

@media (max-width: 480px) {
  .header-username {
    max-width: 96px;
  }
}

.header-mypage-btn:hover {
  background-color: var(--green-50);
}
</style>